import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=6981495b&scoped=true&"
import script from "./SideMenu.vue?vue&type=script&lang=js&"
export * from "./SideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6981495b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6981495b')) {
      api.createRecord('6981495b', component.options)
    } else {
      api.reload('6981495b', component.options)
    }
    module.hot.accept("./SideMenu.vue?vue&type=template&id=6981495b&scoped=true&", function () {
      api.rerender('6981495b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/SideMenu.vue"
export default component.exports